import React from "react";

const CatgryData = [
  { value: "all", label: "All Fields" },
  {
    value: "Rich Text > Rich Text Category",
    label: "Rich Text > Rich Text Category",
  },
  {
    value: "Step > BOM Table for Step Title",
    label: "Step > BOM Table for Step Title",
  },
  {
    value: "Step > Item Code Column Title",
    label: "Step > Item Code Column Title",
  },
  {
    value: "Canvas > Canvas Template",
    label: "Canvas > Canvas Template",
  },
  {
    value: "Users > Role",
    label: "Users > Role",
  },
];

export default CatgryData;
